import ActionConfirmModal from 'component/ActionConfirmModal';
import { getExtendMeetingErrorFeedback } from './meetingExtendFeedback';

/** 日程与详情共用失败反馈，等待延长确认框关闭后再展示。 */
export const showExtendMeetingError = (error: unknown, onRebook: () => void) => {
  const { content, canRebook } = getExtendMeetingErrorFeedback(error);
  setTimeout(() => ActionConfirmModal({
    title: '延长会议失败',
    content,
    okText: canRebook ? '重新预约' : '知道了',
    showCancel: Boolean(canRebook),
    onOk: canRebook ? onRebook : undefined
  }));
};
